import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
  NavigationMenuViewport,
} from "~/components/ui/navigation-menu"

export const starsSortingOptions = [
  { value: "a-z", label: "A → Z" },
  { value: "z-a", label: "Z → A" },
  { value: "newest", label: "Newest" },
  // { value: 'recently-active', label: 'Recently Active'},
]

export interface SortOption {
  value: string
  label: string
}

interface SortingOptionsListProps {
  options: SortOption[]
  onChange: (option: SortOption) => void
}

interface StarsSortingMenuProps {
  currentSortOption: SortOption
  onChange: (option: SortOption) => void
}

const SortingOptionsList: React.FC<SortingOptionsListProps> = ({ options, onChange }) => {
  return (
    <ul className="grid gap-3 p-4 w-[160px]">
      {options.map((option) => (
        <li
          key={option.value}
          className="flex items-center gap-3 text-foreground text-sm hover:font-bold cursor-pointer"
          onClick={() => onChange(option)}>
          {option.label}
        </li>
      ))}
    </ul>
  )
}

export const StarsSortingMenu: React.FC<StarsSortingMenuProps> = ({ currentSortOption, onChange }) => {
  return (
    <NavigationMenu className="mx-6">
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger className="text-foreground text-sm bg-transparent dark:bg-transparent hover:bg-transparent dark:hover:bg-transparent">
            <span>Sort By: {currentSortOption.label}</span>
          </NavigationMenuTrigger>
          <NavigationMenuContent>
            <SortingOptionsList options={starsSortingOptions} onChange={onChange} />
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
      <NavigationMenuViewport />
    </NavigationMenu>
  )
}
